<template>
    <MountingPortal mountTo="body" append>
        <div class="z-5000 fixed inset-0 flex items-center justify-center" style="background: rgba(20, 28, 33, 0.5)">
            <Spinner size="8xl" />
        </div>
    </MountingPortal>
</template>

<script>
import Spinner from '@/components/Spinner'
import { MountingPortal } from 'portal-vue'

export default {
    components: { Spinner, MountingPortal }    
}
</script>